<script lang="ts">
    import { onMount, tick } from 'svelte'

    import Icon from '@iconify/svelte'

    import { gettext as _ } from 'hydria/services/gettext'
    import { signedIn } from 'hydria/services/session'

    import { portal } from 'wdom/services/simplePortal'

    interface Props {
        eid: string
        modal?: boolean
        disabled?: boolean
    }

    let { eid, modal = false, disabled }: Props = $props()

    let mkElement: HTMLDivElement | undefined = $state()
    let element: HTMLInputElement | undefined = $state()
    onMount(() => {
        element = document.getElementById(eid) as HTMLInputElement
        if (!element) {
            console.error(`Minikeyboard: element ${eid} not found`)
        } else if (element.tagName != 'INPUT' && element['type'] != 'TEXT') {
            console.error(`Minikeyboard: element ${eid} not a text input`)
        }
    })

    let visible = $state(false)
    let ready = $state(false)

    let groups = ['àâ', 'éèëê', 'ïî', 'ô', 'ùüû', 'ÿ', 'ç', 'æ', 'œ']
    let styles: string | undefined = $state(undefined)
    let top: number | undefined = $state()
    let left: number | undefined = $state()

    function insert(char: string) {
        if (!element) return
        const start: number = element.selectionStart ? element.selectionStart : 0
        const end: number = element.selectionEnd != null ? element.selectionEnd : element.value.length - 1
        element.value = element.value.slice(0, start) + char + element.value.slice(end)
        // element.value = element.value.splice(start, end - start, char)
        element.focus()
        element.setSelectionRange(start + 1, start + 1)
    }

    // function getBounds(id: string) {
    //     const element = document.getElementById(id)
    //     if (element) return element.getBoundingClientRect()
    // }

    function toggle() {
        visible = !visible
    }
    function open() {
        if (!element) return
        const bounds = element.getBoundingClientRect()

        tick().then(() => {
            if (!element || !mkElement) return
            // const mkBounds = getBounds('minikeyboard')

            top = bounds.top + bounds.height + 10
            left = bounds.left + (bounds.width - mkElement.offsetWidth) / 2

            ready = true
            element.focus()
        })
    }
    function close() {
        ready = false
        if (element != null) element.focus()
    }

    $effect(() => {
        if (element != null) visible ? open() : close()
    })
    $effect(() => {
        styles = visible ? (ready ? `top: ${top}px; left: ${left}px; position: ${modal ? 'fixed' : 'absolute'}` : 'visibility: hidden') : undefined
    })
    $effect(() => {
        if (!$signedIn && visible) visible = false
    })
</script>

<style>
    #minikeyboard.popover {
        left: -9999px;
        top: 0px;
        display: block;
        width: 320px;
        z-index: 1100;
    }
    .popover-content p {
        line-height: 250%;
        text-align: center;
    }
    .popover-content p > span {
        display: inline-block;
        padding: 0 5px;
    }
    .popover-title {
        border-top-left-radius: var(--bs-card-border-radius);
        border-top-right-radius: var(--bs-card-border-radius);
    }

    .arrow {
        position: absolute;
        width: 0;
        height: 0;
        border-width: 0 14px 14px 14px;
        border-style: solid;
        border-color: transparent;
        border-bottom-color: var(--bs-card-border-color);
        top: -14px;
        left: 153px;
    }
    .arrow::after {
        top: 1px;
        content: ' ';
        border-top-width: 0;
        border-bottom-color: #fff;

        position: absolute;
        width: 0;
        height: 0;
        border-width: 0 13px 13px 13px;
        border-style: solid;
        border-color: transparent;
        border-bottom-color: var(--bs-primary);
        /* border-bottom-color: var(--bs-card-bg); */
        margin-left: -13px;
    }
    .card {
        --bs-card-border-color: var(--bs-gray-300);
        border: 1px solid var(--bs-card-border-color);
    }
</style>

<button class="btn btn-outline-secondary accent" type="button" onclick={toggle} class:active={visible} disabled={disabled != null && disabled}>
    <Icon inline icon="fa:keyboard-o" />
</button>

{#if visible && (disabled == null || !disabled)}
    <div id="minikeyboard" use:portal={'minikeyboard'} bind:this={mkElement} style={styles} class="popover bottom">
        <div class="popover-inner card">
            <div class="arrow"></div>
            <div class="popover-title card-header text-bg-primary p-2 text-center">{$_('French accented characters')}</div>
            <div class="popover-content card-body p-2">
                <p>
                    {#each groups as group}
                        <span class="btn-group">
                            {#each group as char}
                                <button type="button" class="btn btn-outline-secondary btn-sm" onclick={() => insert(char)}>
                                    {char}
                                </button>
                            {/each}
                        </span>
                    {/each}
                </p>
            </div>
        </div>
    </div>
{/if}
